import { getRequest } from '@/plugins/api-axios'
import { getURL, companyBaseUrl, getRequestHeaders } from '@/utils/axios'
import { deserialise } from 'kitsu-core'
import { initDialog } from '@/utils/dialog'
import SearchCompanyByOrgNumDialog from '@/views/Company/dialogs/searchCompanyByOrgNum.vue'

export const nationalities = [
    {
        id: 'NOR',
        country: 'nor',
        number: 9,
        regex: /^\d{9}$/gm,
    },
    {
        id: 'SWE',
        country: 'swe',
        number: 10,
        regex: /^\d{6}-?\d{4}$/gm,
    },
    {
        id: 'DNK',
        country: 'dan',
        number: 10,
        regex: /^\d{8}$/gm,
    },
    {
        id: 'FIN',
        country: 'fin',
        number: 10,
        regex: /^\d{7}-?\d$/gm,
    },
    {
        id: 'EST',
        country: 'est',
        number: 10,
        regex: /^\d{8}$/gm,
    },
    {
        id: 'POL',
        country: 'pol',
        number: 10,
        regex: /^\d{10}$/gm,
    },
    {
        id: 'LTU',
        country: 'lit',
        number: 10,
        regex: /^\d{9}|\d{12}$/gm,
    },
]

export async function getCompany(companyId: string, include = '') {
    let { data } = await getRequest(
        getURL({
            path: `companies/${companyId}`,
            base: companyBaseUrl,
            params: {
                include,
            },
        }),
        getRequestHeaders('GET')
    )

    let res = deserialise(data).data

    return res
}

export async function searchCompanies(filters: Record<string, any>, include = '') {
    let { data } = await getRequest(
        getURL({
            path: `companies`,
            base: companyBaseUrl,
            params: {
                ...filters,
                include,
            },
        }),
        getRequestHeaders('GET')
    )

    let res = deserialise(data).data

    return res
}

export async function initSearchCompanyByOrgNum() {
    return await initDialog(SearchCompanyByOrgNumDialog, {})
}
